// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"8477807b","565":"bea0fae6","635":"6f7f7e7a"}[chunkId] + ".chunk.js";
};